import { ref, computed, onUnmounted } from '#imports'

export const useStopwatch = () => {
    const count = ref(0)
    let intervalId: ReturnType<typeof setInterval> | undefined

    const counter = computed(() => {
        let totalSeconds = count.value
        let hours: number | string = Math.floor(totalSeconds / 3600)

        totalSeconds %= 3600

        let minutes: number | string = Math.floor(totalSeconds / 60)
        let seconds: number | string = totalSeconds % 60

        // Add a leading zero to display ex. "04"
        hours = hours.toString().padStart(2, '0')
        minutes = minutes.toString().padStart(2, '0')
        seconds = seconds.toString().padStart(2, '0')

        return `${hours}:${minutes}:${seconds}`
    })

    function startCounter() {
        if (!import.meta.client) return
        if (intervalId) return
        intervalId = setInterval(() => {
            count.value = count.value + 1
        }, 1000)
    }

    onUnmounted(() => {
        clearInterval(intervalId)
        intervalId = undefined
    })

    return {
        startCounter,
        counter,
    }
}
